import React from 'react';
import { SaveButton, useNotify, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { computeSiteValidationIssues } from './siteValidation';

export const SiteSaveButton: React.FC = () => {
    const notify = useNotify();
    const translate = useTranslate();
    const { getValues } = useFormContext();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const values = getValues();
        const { hardErrors } = computeSiteValidationIssues(values, translate);

        if (hardErrors.length === 0) {
            // No custom blocking errors — let React Admin's normal submit flow run
            // (field-level required() validators will highlight any empty fields).
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        const title = translate('resources.sites.validation.fixTheseBeforeSaving', {
            _: 'Please fix the following before saving',
        });
        const body = hardErrors.map((m) => `• ${m}`).join('\n');

        notify(`${title}:\n${body}`, {
            type: 'error',
            multiLine: true,
            autoHideDuration: 12000,
        });

        try {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch {
            window.scrollTo(0, 0);
        }
    };

    return (
        <SaveButton
            onClick={handleClick}
            variant="contained"
            sx={{
                backgroundColor: '#00C853',
                '&:hover': {
                    backgroundColor: '#00A843',
                    boxShadow: '0 4px 12px rgba(0,200,83,0.3)',
                },
            }}
        />
    );
};
